export const iconFontAwesomeMoneySackDollar = (
	<i className="fa-solid fa-sack-dollar"></i>
);
